module.exports = __webpack_public_path__ + "static/img/cat1.ea55a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homes/cat1.png
// module id = uzT0
// module chunks = 1